export default __webpack_public_path__ + "static/9-01c3137011c68622fea222f46db074c2.jpg";